<template>
    <div class="navigation-btns-container" :style="{[$vuetify.rtl ? 'left' : 'right']: '20px'}">
        <div class="navigation-btns-inner-container pa-3" :class="{'navigation-btns': show}">
            <v-btn color="primary" :disabled="!backEnabled" style="min-width: 100px;" :class="{'mr-3': !$vuetify.rtl}" @click="back()">
                {{$t('general.back')}}
            </v-btn>
            <v-btn color="primary" :disabled="!nextEnabled" style="min-width: 100px;" :class="{'mr-3': $vuetify.rtl}" @click="next()">
                {{$t('general.next')}}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import applicationEventHub from "../../../events/applicationEventHub";

    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            nextEnabled: true,
            backEnabled: true,
        }),
        created() {
            applicationEventHub.$on('framework.disable_buttons', this.handleDisable);
        },
        methods: {
            next() {
                applicationEventHub.frameworkNext();
            },
            back() {
                applicationEventHub.frameworkBack();
            },
            handleDisable(btns) {
                if (btns.hasOwnProperty('next')) {
                    this.nextEnabled = btns.next;
                }

                if (btns.hasOwnProperty('back')) {
                    this.backEnabled = btns.back;
                }
            }
        },
        beforeDestroy() {
            applicationEventHub.$off('framework.disable_buttons', this.handleDisable);
        }
    };
</script>

<style>
    .navigation-btns-container{
        position: absolute;
        bottom: 0;
        transform: translateY(-150%);
        overflow: hidden;
    }

    .navigation-btns-inner-container {
        opacity: 0;
        transition: all .4s ease-out;
        background-color: #5A768E;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        box-shadow: inset 0 -5px 10px -10px #000000;
        transform: translateY(100%);
    }

    .navigation-btns {
        opacity: 1;
        transform: translateY(0);
    }
</style>